import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { appelerApi } from "../api/client";
import type { Catalogue } from "../api/types";
import { ProductionCard } from "../components/ProductionCard";

export function Accueil() {
  const [catalogue, definirCatalogue] = useState<Catalogue | null>(null);

  useEffect(() => {
    appelerApi<Catalogue>("/catalogue?taille_page=3")
      .then(definirCatalogue)
      .catch(() => definirCatalogue(null));
  }, []);

  return (
    <>
      <section className="hero">
        <div className="hero__contenu">
          <span className="sur-titre">La scène se prépare ici</span>
          <h1>Trouvez le spectacle qui fera vibrer votre saison.</h1>
          <p>
            Des fiches professionnelles, des disponibilités et des résultats dont
            l’origine est toujours visible. La mise en relation reste directe,
            gratuite et sans commission.
          </p>
          <div className="hero__actions">
            <Link className="bouton bouton--primaire bouton--large" to="/catalogue">
              Explorer le catalogue
            </Link>
            <Link className="bouton bouton--clair bouton--large" to="/inscription">
              Référencer un spectacle
            </Link>
          </div>
          <dl className="hero__chiffres">
            <div>
              <dt>0 €</dt>
              <dd>pour rejoindre le réseau</dd>
            </div>
            <div>
              <dt>5 sources</dt>
              <dd>toujours identifiées</dd>
            </div>
            <div>
              <dt>1 fiche</dt>
              <dd>pour toutes vos diffusions</dd>
            </div>
          </dl>
        </div>
        <div className="hero__scene" aria-hidden="true">
          <div className="projecteur projecteur--gauche" />
          <div className="projecteur projecteur--droite" />
          <div className="hero__affiche">
            <span>À l’affiche</span>
            <strong>Votre prochaine découverte</strong>
            <small>Programmation · diffusion · résultats</small>
          </div>
        </div>
      </section>

      <section className="section section--intro">
        <div>
          <span className="sur-titre sur-titre--sombre">Un réseau utile aux deux côtés</span>
          <h2>Moins de ressaisie. Plus de rencontres.</h2>
        </div>
        <div className="promesses">
          <article>
            <span aria-hidden="true">01</span>
            <h3>Producteurs</h3>
            <p>
              Centralisez médias, disponibilités, représentations et résultats sur
              une fiche stable, prête à partager.
            </p>
          </article>
          <article>
            <span aria-hidden="true">02</span>
            <h3>Structures</h3>
            <p>
              Comparez avec contexte, contactez directement la compagnie et importez
              la fiche dans votre saison.
            </p>
          </article>
          <article>
            <span aria-hidden="true">03</span>
            <h3>Données fiables</h3>
            <p>
              Distinguez en un regard les données vérifiées Tickboss, importées Live,
              déclarées et calculées.
            </p>
          </article>
        </div>
      </section>

      <section className="section section--catalogue">
        <header className="titre-section">
          <div>
            <span className="sur-titre sur-titre--sombre">En ce moment</span>
            <h2>Des productions prêtes à partir en tournée</h2>
          </div>
          <Link to="/catalogue">Voir tout le catalogue <span aria-hidden="true">→</span></Link>
        </header>
        {catalogue?.elements.length ? (
          <div className="grille-productions">
            {catalogue.elements.map((production) => (
              <ProductionCard key={production.id} production={production} />
            ))}
          </div>
        ) : (
          <div className="etat-vide">
            <strong>Le catalogue se prépare.</strong>
            <p>Soyez parmi les premières compagnies à publier une production.</p>
            <Link className="bouton bouton--primaire" to="/inscription">
              Créer une fiche
            </Link>
          </div>
        )}
      </section>

      <section className="appel-final">
        <div>
          <span className="sur-titre">Prêt à ouvrir le rideau ?</span>
          <h2>Votre prochaine collaboration commence par une fiche claire.</h2>
        </div>
        <Link className="bouton bouton--clair bouton--large" to="/inscription">
          Rejoindre Tickboss Production
        </Link>
      </section>
    </>
  );
}
